export default __webpack_public_path__ + "static/media/bg_smll_01.0ac0e2d4.png";